import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { trackPageView } from './google.analytics';

export function usePageTracking() {
	const location = useLocation();

	useEffect(() => {
		const page = `${location.pathname}${location.search}`;

		trackPageView(page, document.title);
	}, [location.pathname, location.search]);
}
